import { communicationService } from '../api';

export const destroyVideoRoom = async (roomSid: string) => {
  await communicationService.post('/destroyRoom', { roomSid });
};
